<template>
  <div class="filter-content">
    <div class="filter-input" v-for="(item, index) in fields" :key="index">
      <vs-input
        v-if="item.type === 'text'"
        :label-placeholder="item.placeholder"
        v-model="fields[index].value"
      />
      <datepicker
        v-if="item.type === 'date'"
        :placeholder="item.placeholder"
        v-on:selected="onSelectedDate($event, index)"
      ></datepicker>
    </div>
    <vs-button color="primary" class="filter-btn-search" @click="onSearch">Buscar</vs-button>
    <vs-button color="danger" type="border" class="filter-btn-search" @click="onClearSearch">Limpar</vs-button>
  </div>
</template>

<script>
import datepicker from "vuejs-datepicker";
import convertDatetimeHelper from '../../helpers/convert-datetime-helper';

export default {
  name: "table-filter",
  props: {
    fields: null // field, placeholder, value
  },
  data() {
    return {
      value1: "",
      value2: ""
    };
  },
  methods: {
    onSearch() {
      const search = this.fields.filter(item => item.value);
      this.$emit("search", search.length === 0 ? null : search);
    },
    onClearSearch() {
      this.fields.map(item => {
        item.value = "";
        return item;
      });
      this.onSearch();
    },
    onSelectedDate(value, index) {
      this.fields[index].value = convertDatetimeHelper.convertDateToStringFormat(value);
    }
  },
  components: {
    datepicker
  }
};
</script>

<style>
.filter-content {
  display: flex;
  margin-bottom: 15px;
  border-bottom: 1px solid #e5e5e5;
}
.filter-input {
  margin-right: 10px;
}
.filter-input input {
  margin-bottom: 5px;
}
.filter-input .vdp-datepicker input {
  margin-top: 17px;
  font-size: .9rem !important;
}
.filter-btn-search {
  margin-right: 10px;
  height: 37px;
  top: 17px;
}
.vdp-datepicker__calendar {
  z-index: 999 !important;
}
</style>